import React from 'react';
import { ExplorerItem } from './types';
interface CompactRowProps {
  item: ExplorerItem;
  onClick: () => void;
  accentColor?: 'blue' | 'purple';
}
export function CompactRow({
  item,
  onClick,
  accentColor = 'blue'
}: CompactRowProps) {
  const Icon = item.icon;
  const isActive = item.usageCount > 0;
  const accentClass = accentColor === 'blue' ? 'text-blue-600 bg-blue-50' : 'text-purple-600 bg-purple-50';
  const hoverClass = accentColor === 'blue' ? 'hover:border-blue-300' : 'hover:border-purple-300';
  const countClass = accentColor === 'blue' ? 'text-blue-600' : 'text-purple-600';
  return <div onClick={isActive ? onClick : undefined} className={`flex items-center justify-between px-2.5 sm:p-3 py-2 sm:py-3 rounded-lg border transition-all gap-2 ${isActive ? `bg-white border-gray-200 cursor-pointer ${hoverClass} hover:shadow-sm` : 'bg-gray-50/50 border-gray-100 opacity-60 cursor-not-allowed'}`} data-id="element-6332" data-mp="d36eso8g8akm">
      
      <div className="flex items-center gap-2.5 sm:gap-4 min-w-0 flex-1" data-id="element-6333" data-mp="3lhx56xda7nmt">
        <div className={`w-7 h-7 sm:w-8 sm:h-8 rounded-lg flex items-center justify-center shrink-0 ${isActive ? accentClass : 'bg-gray-200 text-gray-400'}`} data-id="element-6334" data-mp="tysr8hkqtred">
          
          <Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-6335" data-mp="k8pxug9pmbfi" />
        </div>
        <div className="min-w-0 flex-1" data-id="element-6336" data-mp="k6vf98lwuvel">
          <div className="flex items-center gap-1.5 sm:gap-2 min-w-0" data-id="element-6337" data-mp="fa4xmgugjrr2">
            <code className="text-xs sm:text-sm font-mono font-bold text-gray-900 truncate" data-id="element-6338" data-mp="f7sh884clpg4">
              {item.id}
            </code>
            {!item.isRegistered && <span className="text-[9px] sm:text-[10px] bg-red-100 text-red-700 px-1 sm:px-1.5 py-0.5 rounded font-bold shrink-0" data-id="element-6339" data-mp="685ftmbmcjn2">
                Unreg
              </span>}
          </div>
          <p className="text-[11px] sm:text-xs text-gray-500 line-clamp-1" data-id="element-6340" data-mp="3sh6phx9oiynx">
            {item.description}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2 sm:gap-6 shrink-0" data-id="element-6341" data-mp="1vlio1mmuqrtg">
        {/* Module badges — visible on tablet+ */}
        <div className="hidden md:flex flex-wrap gap-1 justify-end max-w-[10rem]" data-id="element-6342" data-mp="3l50bv5f710xl">
          {Array.from(item.modules).slice(0, 3).map(m => <span key={m} className="text-[10px] font-bold px-1.5 py-0.5 rounded border bg-gray-50 border-gray-200 text-gray-600" data-id="element-6343" data-mp="3pws73t9anuu2">
            
                {m}
              </span>)}
          {item.modules.size > 3 && <span className="text-[10px] text-gray-400 font-medium px-1" data-id="element-6344" data-mp="3g6p4d1cdf2ij">
              +{item.modules.size - 3}
            </span>}
        </div>

        {/* Stats */}
        <div className="text-right min-w-[2.5rem] sm:min-w-[4rem]" data-id="element-6345" data-mp="cpqgeg5t6tys">
          <div className={`text-sm font-black ${isActive ? countClass : 'text-gray-400'}`} data-id="element-6346" data-mp="cmuiusxvi7av">
            
            {item.usageCount}
          </div>
          <div className="text-[10px] text-gray-500 font-medium" data-id="element-6347" data-mp="2pzliddc6cy6">refs</div>
        </div>
      </div>
    </div>;
}